import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.onload = function () {
	//console.log(document.querySelector(".wp-block-ifdigital-if-hanszimmer"));
	//console.log(document.querySelector(".if-hanszimmer-figure-0 img"));
	//console.log(document.querySelector(".if-hanszimmer-elevator-pitch"));

	const hanszimmerBlock = document.querySelector(
		".wp-block-ifdigital-if-hanszimmer",
	);
	const firstImage = document.querySelector(".if-hanszimmer-figure-0 img");
	const middleImage = document.querySelector(".if-hanszimmer-figure-1 img");
	const thirdImage = document.querySelector(".if-hanszimmer-figure-2 img");
	const elevatorPitch = document.querySelector(".if-hanszimmer-elevator-pitch");
	const shows = document.querySelector("#theShows");

	if (
		!hanszimmerBlock ||
		!firstImage ||
		!middleImage ||
		!thirdImage ||
		!elevatorPitch
	) {
		console.warn(
			"Ein oder mehrere Elemente fehlen. Animation wird nicht ausgeführt.",
		);
		return;
	}

	// **Fix: Setze alle Elemente explizit auf opacity: 1 & transform: none**
	gsap.set([firstImage, middleImage, thirdImage, elevatorPitch], {
		opacity: 1,
		transform: "none",
		willChange: "transform, opacity"
	});

	// **ScrollTrigger für den gesamten Block (Scrollweg um 50% verlängert)**
	ScrollTrigger.create({
		trigger: hanszimmerBlock,
		start: "center top",
		end: "+=200dvh", // 50% länger als zuvor
		pin: false,
		pinSpacing: "0",
		scrub: 2,
		markers: false,
	});

	// **1. Bild nach oben schieben & ausblenden**
	gsap.fromTo(
		firstImage,
		{ y: "0vh", scale: 1, opacity: 1, transform: "none" },
		{
			y: "-10vh",
			scale: 1.2,
			opacity: 0,
			immediateRender: false,
			scrollTrigger: {
				trigger: hanszimmerBlock,
				start: "top top",
				end: "bottom bottom", // Länger animieren
				scrub: 2,
			},
		},
	);

	// **2. Bild Blur-Effekt langsam aufbauen**
	gsap.fromTo(
		middleImage,
		{ filter: "blur(0px)", opacity: 1, scale: 1 },
		{
			filter: "blur(20px)",
			scale: 1.2,
			opacity: 1,
			immediateRender: false,
			scrollTrigger: {
				trigger: hanszimmerBlock,
				start: "top top",
				end: "bottom bottom", // Länger animieren
				scrub: 2,
				pin: false,
				pinSpacing: false,
			},
		},
	);

	// **3. Bild nach unten schieben & ausblenden**
	gsap.fromTo(
		thirdImage,
		{ scale: 1, opacity: 1, y: "0vh", filter: "blur(0px)" },
		{
			filter: "blur(10px)",
			y: "100vh",
			scale: 3,
			opacity: 0,
			immediateRender: false,
			scrollTrigger: {
				trigger: hanszimmerBlock,
				start: "-5dvh top",
				end: "bottom 50%", // Länger animieren
				scrub: 2
			},
		},
	);

	// **Elevator-Pitch nach unten schieben & ausblenden**
	gsap.fromTo(
		elevatorPitch,
		{ y: "0vh", opacity: 1 },
		{
			y: "-18vh",
			opacity: 1,
			immediateRender: false,
			scrollTrigger: {
				trigger: hanszimmerBlock,
				start: "-30vh top",
				end: "bottom bottom", // Verlängert
				scrub: 2,
			},
		},
	);

	gsap.fromTo(
		shows,
		{ y: "0vh", opacity: 0 },
		{
			y: "-10vh",
			opacity: 1,
			immediateRender: false,
			scrollTrigger: {
				trigger: hanszimmerBlock,
				start: "top top",
				end: "bottom bottom", // Verlängert
				scrub: 2,
			},
		},
	);
};
